"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFindOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M29.71 28.29L26 24.61a5.44 5.44 0 001-3.11 5.5 5.5 0 10-5.5 5.5 5.44 5.44 0 003.11-1l3.68 3.68zM21.5 25a3.5 3.5 0 113.5-3.5 3.5 3.5 0 01-3.5 3.5zM4 4h24v2H4zM4 10h24v2H4zM4 16h8v2H4zM4 22h8v2H4z" })));
}
exports.default = SvgFindOutline;
//# sourceMappingURL=FindOutline.js.map